// extracted by mini-css-extract-plugin
export default {"chevron":"Chevron_chevron__3nIL8"};